import { useCallback, useState, useMemo, useEffect } from 'react'
import { growl } from '@wmgtech/legato'
import debounce from 'lodash/debounce'
import { useGetCampaignByNameLazyQuery } from '../graphql/queries/searchCampaign.types'
import { Campaign } from 'shared/__gql-types'

export const useSearchProject = () => {
  const [searchResult, setSearchResult] = useState<Campaign[] | undefined>()
  const [searchCampaignQuery, { loading, error }] = useGetCampaignByNameLazyQuery()

  // TODO: Add notification on error
  useEffect(() => {
    if (error) {
      growl.error({ message: 'Search Error. Please try again' })
    }
  }, [error])

  const searchCampaign = useCallback(
    async (term: string, { label_id, space_id }: { label_id?: string, space_id?: string }) => {
      if (typeof label_id !== 'string' && typeof space_id !== 'string') return
      const { data } = await searchCampaignQuery({
        variables: {
          name: term,
          label_id,
          space_id,
        }
      })
      setSearchResult((data?.getCampaignByName?.campaigns ?? undefined) as any)
    },
    [searchCampaignQuery],
  )

  const debouncedSearch = useMemo(() => debounce(searchCampaign, 300), [searchCampaign])

  return {
    searchCampaign: debouncedSearch,
    searchResult,
    isLoading: loading,
  }
}
